<template>
  <v-app class="home-page" :key="updateLanguage">
    <header-comp
      :activeButton="0"
      :userInfo="this.dealersData"
      access="admin"
      v-on:update="onStep1Update"
    />
    <v-tabs centered @change="changeTab">
      <v-tab>{{ "lng_systems_map_view_txt" | translate }}</v-tab>
      <v-tab>{{ "lng_systems_list_view_txt" | translate }}</v-tab>
      <!-- <v-tab v-if="authLevel==3">{{ "lng_dealers_map_view_txt" | translate }}</v-tab> -->
      <v-tab>{{ "lng_users_map_view_txt" | translate }}</v-tab>
      <!-- <v-tab v-if="authLevel==3">{{ "lng_dealers_list_view_txt" | translate }}</v-tab> -->
      <v-tab>{{ "lng_users_list_view_txt" | translate }}</v-tab>
    </v-tabs>
    <div v-if="activeTab === 0" class="map-container">
      <AdminSystemsMap 
        mapType="system"
        :systemData="systemData"
        @markerClicked="markerClicked"
      />
    </div>
    <div v-if="activeTab === 1" class="my-2">
      <v-row class="m-1" v-if="dealerDashbaord">
        <v-col cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['installs-this-month'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_installs_this_month_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['installs-this-year'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_installs_this_year_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['installs-total'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_installs_total_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col v-if="false" cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['service-needed'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_service_needed_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <div class="ma-5">
        <input type="text" v-model="searchSystem" class="search-filter" :placeholder="'lng_search_txt' | translate">
      </div>
      <v-card class="ma-3">
        <v-card-title style="background: gainsboro;">
          {{ "lng_systems_list_txt" | translate }}
          <v-spacer></v-spacer>
          <!-- <v-btn class="mx-2" fab dark small color="#0B7894" @click="openAddSystemModal = true">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn> -->
          <v-btn class="mx-2" fab dark small color="#0B7894" @click="openFiltersModal = true; userTypeFilter=false;">
            <v-icon dark>mdi-filter</v-icon>
          </v-btn>
          <v-tooltip left v-if="authLevel === '0'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" @click="openAssignItselfToggle=true;"
              fab dark small color="#0B7894" v-bind="attrs" v-on="on">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ "lng_assign_itself_txt" | translate }}</span>
          </v-tooltip>
        </v-card-title>
        <v-col v-if="systemData" cols="12" style="overflow: auto;" class="pa-0">
          <v-data-table
            :key="updateLanguage"
            :headers="headers"
            :items="filterSearchSystem"
            class="elevation-1"
            :footer-props="{
              itemsPerPageText: translateRowPrPage
            }"
          >

          <template v-slot:item.system.id="{ item }">
            <span style="cursor: pointer;" @click="markerClicked(item)">{{ item.system.id }}</span>
          </template>
          <template v-slot:item.full_address="{ item }">{{ item.system | formatAddress }}</template>
          <template v-slot:item.system.sysstate="{ item }">
            <v-chip v-if="item.system.sysstate === '0'" color="rgb(130,225,147)" dark x-small>{{ "lng_system_state_ok_txt" | translate }}</v-chip>
            <v-chip v-else-if="item.system.sysstate === '1'" color="rgb(225,128,128)" dark x-small>{{ "lng_system_state_alarm_txt" | translate }}</v-chip>
            <v-chip v-else-if="item.system.sysstate === '2'" color="rgb(223,217,217)" x-small>{{ "lng_system_state_offline_txt" | translate }}</v-chip>
          </template>  
          <template v-slot:item.system.serviceDate="{ item }">
            <v-chip v-if="findMonthsForService(item.system) === 'no'" color="rgb(130,225,147)" dark x-small>{{ "lng_no_service_txt" | translate }}</v-chip>
            <v-chip v-else-if="findMonthsForService(item.system) === 'soon'" color="rgb(225,128,128)" dark x-small>{{ "lng_soon_service_txt" | translate }}</v-chip>
            <v-chip v-else-if="findMonthsForService(item.system) === 'due'" color="rgb(223,217,217)" x-small>{{ "lng_due_service_txt" | translate }}</v-chip>
          </template>
          <template v-slot:item.system.rssidate="{item}">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" v-if="item.system.rssi >= 1 && item.system.rssi < 5 ">
                    <v-icon color="red">mdi-antenna</v-icon>
                  </div>
                  <div  v-bind="attrs" v-on="on" v-else-if="item.system.rssi >= 5  && item.system.rssi < 7">
                    <v-icon color="orange">mdi-antenna</v-icon>
                  </div>
                  <div  v-bind="attrs" v-on="on" v-else-if="item.system.rssi >= 7  && item.system.rssi <= 9">
                    <v-icon color="yellow">mdi-antenna</v-icon>
                  </div>
                  <div  v-bind="attrs" v-on="on" v-else-if="item.system.rssi >= 10  && item.system.rssi <= 12">
                    <v-icon color="blue">mdi-antenna</v-icon>
                  </div>
                  <div  v-bind="attrs" v-on="on" v-else-if="item.system.rssi >= 13  && item.system.rssi < 20">
                    <v-icon color="purple">mdi-antenna</v-icon>
                  </div>
                  <div v-bind="attrs" v-on="on" v-else-if="item.system.rssi >= 20">
                    <v-icon color="green">mdi-antenna</v-icon>
                  </div>
              </template>
                <span>{{"lng_th_rssi" | translate}}:{{item.system.rssi}}</span><br>
                <span>{{"lng_th_rssi_date" | translate}}:{{item.system.rssidate}}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.system.lastservice="{ item }">
            <v-row style="align-items: center;">
              <span>{{ getOnlyDate(item.system.lastservice) }}</span>
              <v-icon v-if="authLevel==='0'" style="cursor: pointer;" color="red" 
                @click="systemItem=item.system; openAlterDateModal=true; singleSystemData=item.system;">mdi-restart</v-icon>
            </v-row>
          </template>
          <template v-slot:item.system.installdate="{ item }">
            <span>{{ getOnlyDate(item.system.installdate) }}</span>
          </template>
          <template v-slot:item.action="{ item }">    
            <v-btn class="mx-2" @click="selectedSystemId=item.system.id; eventsModalKey += 1; openEventsModal=true" x-small>{{ "lng_menu_eventlogs" | translate }}</v-btn>
          </template>
          <template v-slot:item.system.servicecontract="{ item }">
            <span>{{ item.system.servicecontract == "1" ? "lng_yes_txt" : "lng_no_txt" | translate }}</span>
          </template>
          <template v-slot:item.system.subscription="{ item }">
            <span>{{ formatSubscriptionTierLabel(item.system.subscription) }}</span>
          </template>
          <template v-slot:item.system.uwsequipment="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="cursor: help;">
                  {{
                    truncateText(
                      equipmentTypeMapping(item.system.uwsequipment),
                      10
                    )
                  }}
                </span>
              </template>
              <span>{{ equipmentTypeMapping(item.system.uwsequipment) }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.system.internalcomment="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="cursor: help;">
                  {{ truncateText(item.system.internalcomment,10) }}
                </span>
              </template>
              <span>{{ item.system.internalcomment }}</span>
            </v-tooltip>
          </template>
          </v-data-table>
        </v-col>
      </v-card>
    </div>
    <div v-if="activeTab === 2" class="map-container">
      <AdminSystemsMap
        mapType="users"
        :systemData="dealerUsers"
        @markerClicked="dealerMarkerClicked"
      />
    </div>
    <div v-if="activeTab === 3" class="my-2">
      <v-row class="m-1" v-if="dealerDashbaord">
        <v-col v-if="false" cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['total-dealers'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_total_dealers_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <div class="ma-5">
        <input type="text" v-model="searchUser" class="search-filter" :placeholder="'lng_search_txt' | translate">
      </div>
      <v-card class="ma-3">
        <v-card-title style="background: gainsboro;">
          {{ "lng_users_list_view_txt" | translate }}
          <v-spacer></v-spacer>
          <v-btn v-if="authLevel === '3'" class="mx-2" fab dark small color="#0B7894" @click="openFiltersModal = true; userTypeFilter=true;">
            <v-icon dark>mdi-filter</v-icon>
          </v-btn>
          <v-tooltip left v-if="authLevel === '3'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" @click="openEditUserModal=true; editUserModalKey += 1; selectedUser={}; editOrCreateType='create'"
              fab dark small color="#0B7894" v-bind="attrs" v-on="on">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ "lng_create_new_user_txt" | translate }}</span>
          </v-tooltip>
        </v-card-title>
        <v-col v-if="dealerUsers" cols="12" style="overflow: auto;" class="pa-0">
          <v-data-table
            :headers="dealerTableHeaders"
            :items="filterSearchUser"
            class="elevation-1"
            :footer-props="{
              itemsPerPageText: translateRowPrPage
            }"
          >
            <template v-slot:item.email="{ item }">
              <span style="cursor: pointer;" @click="dealerMarkerClicked(item)">{{ item.email }}</span>
            </template>
            <template v-slot:item.full_address="{ item }">{{ item | formatAddress }}</template>
            <template v-slot:item.userType="{ item }">
              <userRoles :roleKey="item.authlevel" templateType="chip"/>
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-2" @click="openEditUserModal=true; editUserModalKey += 1; selectedUser=item; editOrCreateType='edit'"
                  fab x-small v-bind="attrs" v-on="on">
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <!-- <span>{{ "lng_edit_user_txt" | translate }}</span> -->
                <span>{{ "lng_edit_txt" | translate }} {{ getTextBasedOnRoles(item) }}</span>
              </v-tooltip>
            </template>

          </v-data-table>
        </v-col>
      </v-card>
    </div>
    <SystemInfoModal
      :changeKey="infoModalKey"
      :dealer-token="adminToken"
      :dialog-title="'lng_box_detail_key_txt' | translate"
      :system-data="systemItem"
      :all-dealers="dealerUsers"
      :openDialog="openInfoModal"
      :closeDialog="closeInfoModalFunc"
      :employee-data="employeesData"
    ></SystemInfoModal>
    <AddSystem
      :dealer-token="adminToken"
      :dialog-title="'lng_add_system_toDealer_txt' | translate"
      :openDialog="openAddSystemModal"
      :closeDialog="closeAddSystemModalFunc"
    />
    <FiltersDialog
      :dealer-token="adminToken"
      :dialog-title="'lng_choose_filters_txt' | translate"
      :openDialog="openFiltersModal"
      :userTypeFilter="userTypeFilter"
      :closeDialog="closeFiltersModalFunc"
      @applyFilters="applyFilters"
    />
    <DealerInfoModal
      :admin-token="adminToken"
      :dialog-title="'lng_user_detail_txt' | translate"
      :dealer-data="dealerItem"
      :openDialog="openDealerInfoModal"
      :closeDialog="closeDealerInfoModalFunc"
      :systemData="systemData"
    ></DealerInfoModal>
    <CreateEditUser
      :changeKey="editUserModalKey"
      :editOrCreateType="editOrCreateType"
      :user-data-prop="selectedUser"
      :openDialog="openEditUserModal"
      :closeDialog="closeEditUserModalFunc"
      @refreshUsers="fetchDealersInfo(adminToken)"
    />
    <AlterServiceDate
      :openDialog="openAlterDateModal"
      :systemData="singleSystemData"
      :closeDialog="closeAlterServiceDateFunc"
      @refreshSystemsData="fetchUserSystems(adminToken)"
    />
    <AssignSystemItself 
      :user-token="adminToken"
      :openDialog="openAssignItselfToggle"
      :closeDialog="closeAssignItselfModalFunc"
      @updateLocalData="fetchUserSystems(adminToken)"
    />
    <EventItems
      :changeKey="eventsModalKey"
      :dialog-title="'lng_menu_eventlogs' | translate"
      :openDialog="openEventsModal"
      :closeDialog="closeEventsModalFunc"
      :systemId="selectedSystemId"
      :userToken="adminToken"
    />
  </v-app>
</template>

<script>
// @ is an alias to /src
import Menu from "../../components/Menu.vue";
import { LMap, LTileLayer, LMarker, LIcon, LTooltip } from "vue2-leaflet";
import L from "leaflet";
import GlobalService from "../../services/global-service";
import HeaderComp from "../../components/HeaderComp";
import { translateFunc } from "../../common/Filters.js"
import { formatSubscriptionTierLabel, getTextBasedOnRoles } from "../../common/HelperFunctions"
import AddSystem from "../../components/dealer/AddSystem"
import FiltersDialog from "../../components/dealer/FiltersDialog"
import DealerInfoModal from "../../components/admin/DealerInfoModal"
import UserRoles from "../../components/admin/UserRoles";
import moment from "moment";
import AdminSystemsMap from "../../components/admin/AdminSystemsMap";
import CreateEditUser from "../../components/admin/CreateEditUser";
import SystemInfoModal from "../../components/admin/SystemInfoModal"
import filterSearchSystem from "../../mixins/SearchFilter"
import filterSearchUser from "../../mixins/SearchFilter"
import onStep1Update from "../../mixins/ChangeLanguage"
import AlterServiceDate from "../../components/admin/AlterServiceDate.vue"
import AssignSystemItself from "../../components/dealer/AssignSystemItself.vue"
import EventItems from "../../components/admin/EventItems.vue"
import { equipmentTypeValues } from "../../common/Constant.js";


export default {
  name: "AdminHome",
  components: {
    Menu,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    HeaderComp,
    AddSystem,
    FiltersDialog,
    DealerInfoModal,
    UserRoles,
    AdminSystemsMap,
    CreateEditUser,
    SystemInfoModal,
    AlterServiceDate,
    AssignSystemItself,
    EventItems
  },
  data() {
    return {
      searchUser:'',
      searchSystem:'',
      adminToken: undefined,
      authLevel: undefined,
      systemData: undefined,
      singleSystemData: undefined,
      systemItem: {},
      activeTab: 0,
      employeesData:undefined,
      headers: [
        { width: '120px' , text: translateFunc('lng_th_systemId'), value: 'system.id' },
        { width: '150px' , text: translateFunc('lng_th_address_txt'), value: 'full_address' },
        { width: '150px' , text: translateFunc('lng_th_alarm_email_txt'), value: 'system.alarmemail' },
        { width: '150px' , text: translateFunc('lng_th_alarm_phone_txt'), value: 'system.alarmsms' },
        { width: '150px' , text: translateFunc('lng_th_sewer_type_txt'), value: 'system.sewertype' },
        { width: '150px' , text: translateFunc('lng_equipment_type_txt'), value: 'system.uwsequipment' },
        { width: '120px' , text: translateFunc('lng_th_subscription_txt'), value: 'system.subscription' },
        { width: '150px' , text: translateFunc('lng_th_service_contract_txt'), value: 'system.servicecontract' },
        { width: '120px' , text: translateFunc('lng_th_service_date_txt'), value: 'system.lastservice' },
        { width: '150px' , text: translateFunc('lng_th_sysStatus_txt'), value: 'system.serviceDate' },
        { width: '120px' , text: translateFunc('lng_th_install_date_txt'), value: 'system.installdate' },
        { width: '130px' , text: translateFunc('lng_th_sysState_txt'), value: 'system.sysstate' },
        { width: '130px' , text: translateFunc('lng_th_note_txt'), value: 'system.internalcomment' },
        { width: '130px' , text: translateFunc('lng_th_rssi'), value: 'system.rssidate', sortable: true },
        { width: '150px' , text: translateFunc('lng_th_actions'), value: 'action', sortable: false },

        /* { text: translateFunc('lng_th_assign_user_txt'), value: 'system.assignUser' }, */
      ],
      dealerTableHeaders: [
        { width: '120px', text: translateFunc('lng_th_user_type_txt'), value: 'userType', sortable: false, },
        { width: '120px', text: translateFunc('lng_th_email_txt'), value: 'email' },
        { width: '150px', text: translateFunc('lng_invoice_email_text'), value: 'invoiceemail' },
        { width: '200px', text: translateFunc('lng_th_name_txt'), value: 'name' },
        { width: '200px', text: translateFunc('lng_th_companyName_txt'), value: 'companyname' },
        { width: '100px', text: translateFunc('lng_th_cvr_txt'), value: 'cvr' },
        { width: '250px', text: translateFunc('lng_th_address_txt'), value: 'full_address' },
        { width: '120px', text: translateFunc('lng_th_lastActive_txt'), value: 'lastlogin' },
        { width: '120px', text: translateFunc('lng_th_actions'), value: 'action', sortable: false },
      ],
      listLoading: false,
      dealerDashbaord: undefined,
      filteredData: undefined,
      dealersData: undefined,
      dealerUsers: undefined,
      filteredDealerUsers: undefined,
      dealerItem: {},
      assignedUsers: [],
      selectedUser: {},
      editOrCreateType: 'create',

      openInfoModal: false,
      infoModalKey: 1,
      openAddSystemModal: false,
      openDealerInfoModal: false,
      openFiltersModal: false,
      openEditUserModal: false,
      editUserModalKey: 1,
      userTypeFilter: false,
      openAlterDateModal: false,
      openAssignItselfToggle: false,
      selectedSystemId: null,
      openEventsModal: false,
      eventsModalKey: 1,
    };
  },
  computed: {
    translateRowPrPage(){
      return translateFunc('lng_rows_perpage_txt')
    },
  },
   mounted() {
    let token = sessionStorage.getItem("userToken");
    this.authLevel = sessionStorage.authLevel;
    // let token = "0923bf24d543bc0f1e9a3a091efc7345d4f1c85cde7f896e9d572d6e5b91529047d17b05f9be03287973b81fd8e84d4edacfa7a95fba546c6505a5860780c1cd";
    this.adminToken = token;
    
    this.listLoading = true;
    this.fetchDealersInfo(token);
    this.fetchUserSystems(token);
    this.fetchDashboardInfo(token);
    this.fetchEmployeesList(token);

    // this.fetchDealerUsers(token);
  },
  mixins:[filterSearchSystem, filterSearchUser, onStep1Update],

  methods: {
    getTextBasedOnRoles,
    formatSubscriptionTierLabel,
    changeTab(tabnumber){
      this.activeTab = tabnumber;
    },
    getOnlyDate (date) {
      return date ? moment(date).format("DD/MM-YYYY") : "";
    },
    async fetchEmployeesList(token) {
      let data = await GlobalService.getEmployeesList(token);
      if (data.employees) {
        this.employeesData = data.employees
        // this.employeesData = data.employees.map(item => item.name);
      }
    },
    async fetchUserSystems(token) {
      let data = await GlobalService.getDealerSystems(token);
      if (data.systems) {
        this.systemData = data.systems;
        this.filteredData = data.systems;
      }
      if (this.systemData && this.systemData.length) {
        this.center = L.latLng(this.systemData[0].system.geolat, this.systemData[0].system.geolng);
      }
    },
    async fetchDashboardInfo(token){
      this.dealerDashbaord = await GlobalService.getDealerDashboard(token);
    },
    async fetchDealersInfo(token){
      let data = await GlobalService.getdealerinfo(token);
      if (data.dealer ) {
        this.dealersData = data.dealer;
        sessionStorage.setItem("userData", JSON.stringify(data.dealer));
        this.fetchDealerUsers(token);
      }
    },
    async fetchDealerUsers(token){
      if(this.authLevel === "3"){
        let data = await GlobalService.getAdminDealers(token);
        if (data.systems ) {
          this.dealerUsers = data.systems;
          this.filteredDealerUsers = data.systems;
        }
      } else {
        let data = await GlobalService.getDealerDealers(token, this.dealersData.id);
        if (data.dealers &&  data.dealers.length) {
          this.dealerUsers = [...new Map(data.dealers.map(item => [item["id"], item])).values()];
        } 
      }
      if (this.dealerUsers && this.dealerUsers.length) {
        this.dealerMapCenter = L.latLng(this.dealerUsers[0].geolat, this.dealerUsers[0].geolng);
      }
    },
    markerClicked(box) {
      this.systemItem = box;
      this.openInfoModal = true;
      this.infoModalKey += 1;
      /* router.push("/event-logs"); */
    },
    dealerMarkerClicked(item){
      this.dealerItem = item;
      this.openDealerInfoModal = true;
    },
    findMonthsForService(item){
      if(item.lastservice){
        let monthDifference =  moment(new Date()).diff(new Date(item.lastservice), 'months', true);
        if(monthDifference <= 9){
          return "no"
        } else if(monthDifference <= 12){
          return "soon"
        } else if(monthDifference > 12){
          return "due"
        }
      }
    },
    async assignEmployee(item){
      let data = await GlobalService.assignEmployeeToSystem(this.adminToken, item.id, item.employee.id);
      if (data.status !== 0) {
        this.fetchUserSystems(this.adminToken);
      }
    },
    async applyFilters(conditions){
      let data1 = this.systemData;
      let data2 = this.systemData;
      let data3 = this.systemData;
      let userTypeFilteredData = this.dealerUsers;
      if(conditions.employee || conditions.service || conditions.state){
        if(conditions.employee){
          data1 = await this.systemData.filter(a =>{
            if(a.system.employee === conditions.employee.id){
              return 1;
            }
          })
          this.filteredData = data1;
        }
        if(conditions.service){
          data2 = await data1.filter(a =>{
            if(this.findMonthsForService(a.system) === conditions.service){
              return 1;
            }
          })
          this.filteredData = data2;
        }
        if(conditions.state){
          data3 = await data2.filter(a =>{
            if(a.system.sysstate === conditions.state){
              return 1;
            }
          })
          this.filteredData = data3;
        }
      } else {
        this.filteredData = this.systemData;
      }

      if(conditions.userType){
        userTypeFilteredData = await this.dealerUsers.filter(a =>{
          if(a.authlevel === conditions.userType){
            return 1;
          }
        })
        this.filteredDealerUsers = userTypeFilteredData;
      } else {
        this.filteredDealerUsers = this.dealerUsers;
      }
    },
    closeInfoModalFunc(){
      this.openInfoModal = false;
    },
    closeDealerInfoModalFunc(){
      this.openDealerInfoModal = false
    },
    closeAddSystemModalFunc(){
      this.openAddSystemModal = false
    },
    closeFiltersModalFunc(){
      this.openFiltersModal = false;
    },
    closeEditUserModalFunc(){
      this.openEditUserModal = false;
    },
    closeAlterServiceDateFunc(){
      this.openAlterDateModal = false
    },
    closeAssignItselfModalFunc(){
      this.openAssignItselfToggle = false;
    },
    closeEventsModalFunc(){
      this.openEventsModal = false;
    },
    equipmentTypeMapping(uwsequipment){
      let eqTypeIndex = equipmentTypeValues.findIndex(
        (e) => e.value === uwsequipment
      );
      if (eqTypeIndex !== -1) {
        return translateFunc(equipmentTypeValues[eqTypeIndex]?.name)
      } else {
        return translateFunc('lng_select_eq_type_txt')
      }
    },
    truncateText(value, maxChars = 10) {
      const text = String(value || '');
      if (text.length <= maxChars) return text;
      return `${text.slice(0, maxChars)}...`;
    }
  }
};
</script>
<style scoped>
.status-0 {
  background-color: rgb(130,225,147)
}
.status-1 {
  background-color: rgb(225,128,128)
}
.status-other {
  background-color: rgb(223,217,217)
}
.home-page {
  height: 100%;
}
.d-menu-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.floating-button-container {
  position: absolute;
  top: 3rem;
  right: 3rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
}
.floating-button-container .v-btn {
  margin-bottom: 0.5rem;
}
.alert-on-map {
  position: absolute !important;
  right: 20px;
  z-index: 9999;
  bottom: 0;
}
.map-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.v-card {
  box-shadow: 0px 0px 0px 0px !important;
}
.map-height {
  height: calc(100vh - 80px);
}
.v-tabs {
  flex: 0 !important;
}
.dropdown-style {
  min-width: 200px;
  font-size: 12px;
}
.user-selection-div {
  display: flex;
  align-items: center;
  margin: 5px 10px;
}
.user-selection-div div {
  min-width: 16px;
  position: relative;
  top: 1px;
}
.dropdown-list-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.search-filter-form{
  padding:20px;
}
.search-filter{
  background: #fff;
  background: #fff;
  padding: 10px;
  width: 100%;
}
@media only screen and (max-width: 768px){
  .map-height {
    height: calc(100vh - 65px);
  } 
}
</style>
